import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15C10.1599 15 11.2407 14.6716 12.1573 14.1032C12.5094 13.8849 12.9717 13.9932 13.19 14.3453C13.4083 14.6973 13.2999 15.1596 12.9479 15.3779C11.8008 16.0894 10.4472 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 9.82832 16.297 10.7326 15.7882 11.4322C15.2511 12.1706 14.4015 12.6323 13.2897 12.5313C12.3872 12.4492 11.6111 11.9975 11.0927 11.3421C10.3872 12.2492 9.30127 12.7967 8.10377 12.6284C6.20669 12.3618 5.07401 10.4456 5.34248 8.53532C5.61096 6.62501 7.22792 5.09533 9.125 5.36194C9.80428 5.45741 10.3856 5.76436 10.8396 6.20681C10.9259 5.8298 11.2889 5.57622 11.6783 5.63279C12.0882 5.69232 12.3723 6.07289 12.3127 6.4828L11.9265 9.142C11.9265 9.14229 11.9264 9.14258 11.9264 9.14287C11.792 10.0869 12.4757 10.9511 13.4255 11.0374C13.9881 11.0886 14.3347 10.8805 14.5752 10.5498C14.844 10.1803 15 9.61632 15 9C15 5.68629 12.3137 3 9 3ZM8.91624 6.84735C8.01964 6.72134 7.00812 7.46162 6.82789 8.74408C6.64765 10.0265 7.41593 11.017 8.31253 11.143C9.20913 11.269 10.2206 10.5287 10.4009 9.24623C10.5811 7.96377 9.81284 6.97335 8.91624 6.84735Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }